/* eslint-disable @ngrx/avoid-dispatching-multiple-actions-sequentially */
/* eslint-disable @ngrx/no-dispatch-in-effects */
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, EMPTY, finalize, map, tap } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Tenant } from 'src/app/core/models/tenant';
import { User } from 'src/app/core/models/users';
import { unsetLoading } from 'src/app/loading/state/actions/loading.actions';
import { UserTenantService } from '../../services/user-tenant.service';
import { clearMessage, failedLogin, logoutUser, successfullLogin } from '../actions/auth.actions';
import {
  loadUserTenantFailure,
  loadUserTenantSuccess,
} from '../actions/user-tenant.actions';
import { selectUserRoles } from '../selectors/auth.selectors';

@Injectable()
export class UserTenantEffects {
  private actions$ = inject(Actions);
  private tenantSvc = inject(UserTenantService);
  private router = inject(Router);
  private store = inject(Store);


  // load user tenant
  loginSuccess$ = createEffect(() =>
    { return this.actions$.pipe(
      ofType(successfullLogin),
      concatMap(({ user }) => {
        if (user.roles.includes(User.UserRole.NATIVA)) {
           // redirect nativa
           this.router.navigate(['mgmt', 'tenants']);
           // eslint-disable-next-line @ngrx/no-dispatch-in-effects
           this.store.dispatch(unsetLoading());
           return EMPTY;
        } else {
          /*
              Multi-tenant is supported but this application uses a single tenant model.
              If tenant is disabled the user should be redirected to login with a message.
          */
          return this.tenantSvc.loadUserTenant(user?.tenants[0]).pipe(
            tap((tenant: Tenant.Tenant) => {
              if(!tenant.enabled) {
                this.store.dispatch(failedLogin({errorMessage: 'La tua azienda potrebbe non essere attiva. Contatta l\'assistenza'}))
              }
            }),
            map((tenant) => loadUserTenantSuccess({ tenant })),
            catchError(async () =>
              loadUserTenantFailure({ error: 'Impossibile accedere. Contatta l\'assistenza.' })
            ),
            finalize(() => {
              this.store.dispatch(unsetLoading())
              this.store.dispatch(clearMessage())
            })
          );
        }
      })
    ) }
  );

   // after successfully loading user tenant redirect user to the appropriate page based on his role.
  loadedUserTenantSuccess$ = createEffect(
    () =>
      { return this.actions$.pipe(
        ofType(loadUserTenantSuccess),
        concatLatestFrom(() => this.store.select(selectUserRoles)),
        tap(([tenant, roles]) => {
          const userRoles = roles as User.UserRole[];
          if (
            userRoles.includes(User.UserRole.USER) &&
            userRoles.includes(User.UserRole.MANAGER)
          ) {
            this.router.navigate(['home']);
            return;
          } else {
            this.router.navigate(['mgmt', 'tenants'])
            return;
          }
        }),
      ) },
    { dispatch: false }
  );
}
